import { useShortcutContext } from "@/hooks/useShortcutContext"
import type { ShortcutAction } from "@/utils/shortcuts"
import { useEffect } from "react"

export const useShortcut = (action: ShortcutAction, handler: () => void) => {
	const { registerShortcut } = useShortcutContext()

	useEffect(() => {
		registerShortcut(action, handler)
	}, [action, handler, registerShortcut])
}
